module.exports = __webpack_public_path__ + "static/10(5)-cbbff9ac72e08ac040b169db341f44c0.jpg";